import { render } from "./forgetPass.vue?vue&type=template&id=c7acc406&scoped=true"
import script from "./forgetPass.vue?vue&type=script&lang=js"
export * from "./forgetPass.vue?vue&type=script&lang=js"

import "./forgetPass.vue?vue&type=style&index=0&id=c7acc406&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7acc406"]])

export default __exports__